<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.835 15.835V11.335C10.835 10.8683 10.835 10.6349 10.7442 10.4566C10.6643 10.2998 10.5368 10.1723 10.38 10.0925C10.2018 10.0016 9.9684 10.0016 9.50169 10.0016H7.16836C6.70165 10.0016 6.46829 10.0016 6.29003 10.0925C6.13323 10.1723 6.00574 10.2998 5.92585 10.4566C5.83502 10.6349 5.83502 10.8683 5.83502 11.335V15.835M14.1684 15.835V3.50163C14.1684 2.56821 14.1684 2.1015 13.9867 1.74498C13.8269 1.43137 13.5719 1.17641 13.2583 1.01662C12.9018 0.834961 12.4351 0.834961 11.5017 0.834961H5.16836C4.23493 0.834961 3.76822 0.834961 3.4117 1.01662C3.0981 1.17641 2.84313 1.43137 2.68334 1.74498C2.50169 2.1015 2.50169 2.56821 2.50169 3.50163V15.835M15.835 15.835H0.835022M6.25169 5.00163H6.26002M10.4184 5.00163H10.4267M6.66836 5.00163C6.66836 5.23175 6.48181 5.41829 6.25169 5.41829C6.02157 5.41829 5.83502 5.23175 5.83502 5.00163C5.83502 4.77151 6.02157 4.58496 6.25169 4.58496C6.48181 4.58496 6.66836 4.77151 6.66836 5.00163ZM10.835 5.00163C10.835 5.23175 10.6485 5.41829 10.4184 5.41829C10.1882 5.41829 10.0017 5.23175 10.0017 5.00163C10.0017 4.77151 10.1882 4.58496 10.4184 4.58496C10.6485 4.58496 10.835 4.77151 10.835 5.00163Z"
      stroke="currentColor"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
